import { render, staticRenderFns } from "./ChooseAdAccountOnboarding.vue?vue&type=template&id=b1431b04&scoped=true&lang=pug"
import script from "./ChooseAdAccountOnboarding.vue?vue&type=script&lang=js"
export * from "./ChooseAdAccountOnboarding.vue?vue&type=script&lang=js"
import style0 from "./ChooseAdAccountOnboarding.vue?vue&type=style&index=0&id=b1431b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1431b04",
  null
  
)

export default component.exports